import React, { useEffect, useState } from 'react';

import { Bouwdeel, Gateway, IdRegistration, Status } from 'src/common/types';

export type GatewayProps = {
  registration: IdRegistration;
  updateRegistration: (name: string, value: string) => void;
  bouwdeel?: Bouwdeel;
};

export const GatewayComponent = ({ registration, updateRegistration, bouwdeel }: GatewayProps) => {
  const [allowedGateways, setAllowedGateways] = useState<Gateway[]>([]);
  const [vlan, setVlan] = useState('');

  useEffect(() => {
    if (!bouwdeel) {
      return;
    }
    const filteredGateways = bouwdeel.gateways.filter(gateway => gateway.verdiepingen.map(v => v.code).includes(registration.floor));
    setAllowedGateways(filteredGateways);
    if(!filteredGateways.find(gateway => gateway.ip_address === registration.gateway)) {
      updateRegistration('gateway', filteredGateways.length > 0 ? filteredGateways[0].ip_address : '');
      setVlan(filteredGateways.length > 0 ? filteredGateways[0].vlan || '' : '');
    } 
  }, [registration.floor, bouwdeel]);

  useEffect(() => {
    if (registration.parent_beyond) {
      updateRegistration('gateway', registration.parent_beyond.gateway);
    }
  }, [registration.parent_beyond]);

  useEffect(() => {
    if (!registration.gateway) {
      setVlan('');
    } else {
      setVlan(bouwdeel?.gateways.find(gateway => gateway.ip_address === registration.gateway)?.vlan || '');
    }
  }, [registration.gateway]);

  return (
    <>
      {registration.status !== Status.MIGRATED ? (
        <>
          <div className="property">
            <label htmlFor="gateway">Gateway</label>
            {!registration.parent_beyond && bouwdeel ? (
              <select
                name="gateway"
                value={registration.gateway}
                onChange={e => updateRegistration('gateway', e.target.value)}
                className={registration.gateway === '' ? 'error' : ''}
              >
                <option value="" disabled hidden>
                  Selecteer een gateway
                </option>
                {allowedGateways.map((option, index) => (
                  <option key={index} value={option.ip_address}>
                    {option.ip_address}
                  </option>
                ))}
              </select>
            ) : (
              <input type="text" id="gateway" name="gateway" value={registration.gateway || ''} disabled={true}></input>
            )}
          </div>
          <div className="property">
            <label>VLAN</label>
            <div className="display-value">
              <span>{vlan}</span>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
